import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => ({
  loading: false,
  status: null,
  error: null
});

const hangings = createReducer(getDefaultState(), {
  [Constants.hangings.load]: () => ({ loading: true, status: null, error: null }),
  [Constants.hangings.loaded]: (state, { hangingMarks }) => ({
    ...state, hangingMarks, loading: false
  }),
  [Constants.hangings.update]: (state, {
    first, second, kind, isAdd
  }) => {
    const { hangingMarks } = state;
    let newMarks = [...hangingMarks];
    if (isAdd) {
      newMarks.push({ first, second, kind });
    } else {
      const index = hangingMarks.findIndex((m) => (
        ((m.first === first && m.second === second) || (m.first === second && m.second === first))
        && m.kind === kind
      ));
      newMarks[index] = null;
      newMarks = newMarks.filter(m => !!m);
    }
    return {
      ...state,
      hangingMarks: newMarks,
      status: null,
      error: null
    };
  },
  [Constants.hangings.reset]: (state) => ({
    ...state,
    hangingMarks: [],
    status: null,
    error: null
  }),
  [Constants.hangings.saving]: (state) => ({
    ...state,
    loading: true,
    status: 'saving',
    error: null
  }),
  [Constants.hangings.saved]: (state, { hangingMarks }) => ({
    ...state,
    loading: false,
    hangingMarks,
    status: 'saved',
    error: null
  }),
  [Constants.hangings.failed]: (state, { error }) => ({
    ...state,
    loading: false,
    status: 'failed',
    error
  }),
  [Constants.hangings.dismissStatus]: (state) => ({
    ...state,
    status: null,
    error: null
  })
});

export default hangings;
